import api from '@a/config';

const path = 'v1/messmittel/standort';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
};
